import React from 'react';

interface ProjectProgressBarProps {
  taskCount: number;
  doneTaskCount: number;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  className?: string;
}

export const ProjectProgressBar: React.FC<ProjectProgressBarProps> = ({
  taskCount,
  doneTaskCount,
  size = 'sm',
  showLabel = true,
  className = '',
}) => {
  if (taskCount === 0) {
    if (!showLabel) return null;
    return (
      <div className={`text-xs text-muted-foreground ${className}`}>
        Brak zadań
      </div>
    );
  }

  const percent = Math.round((doneTaskCount / taskCount) * 100);
  const isComplete = doneTaskCount >= taskCount;
  const barHeight = size === 'md' ? 'h-2' : 'h-1.5';

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {showLabel && (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>
            {doneTaskCount} / {taskCount} zad.
          </span>
          <span className={isComplete ? 'text-primary font-medium' : ''}>
            {percent}%
          </span>
        </div>
      )}
      <div
        className={`w-full ${barHeight} bg-muted rounded-full overflow-hidden`}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Postęp projektu: ${percent}%`}
      >
        <div
          className="h-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};
